<script setup lang="ts">
import { WebCutEditor } from '../src';
</script>

<template>
    <WebCutEditor />
</template>
